import { gql } from '@apollo/client';

const GET_LEGISLATION = gql`
    query legislation {
        legislation
    }
`;

export default GET_LEGISLATION;
